import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const EventTile = styled.div<{
  color: string
  blockWidth: number
  blockHeight: number
  isActive: boolean
}>`
  background-color: ${({ color }) => color};
  cursor: ${({ isActive }) => (isActive ? 'move' : 'default')};
  height: ${({ blockHeight }) => `${blockHeight}px`};
  overflow: hidden;
  pointer-events: bounding-box;
  position: absolute;
  width: ${({ blockWidth }) => `${blockWidth}px`};
  z-index: 3;
`

export const EventInfo = styled.div`
  pointer-events: none;
`

export const EventText = styled.p`
  font-size: 10px;
`

export const ResizeIcon = styled(FontAwesomeIcon)<{ isActive: boolean }>`
  bottom: 0;
  cursor: ns-resize;
  display: ${({ isActive }) => (isActive ? 'block' : 'none')};
  height: 20px;
  left: calc(50% - 10px);
  position: absolute;
  width: 20px;
`

export const IconContainer = styled.div`
  bottom: 0;
  display: flex;
  height: 12px;
  justify-content: space-between;
  margin: 0 3px 3px 0;
  position: absolute;
  width: 100%;
`

export const IconSubContainer = styled.div`
  display: flex;
  height: 12px;
`

export const InfoIcon = styled(FontAwesomeIcon)`
  bottom: 0;
  height: 12px;
  margin: 0 3px;
  right: 0;
  width: 12px;
`
